import React from 'react'
import { WContainer, WLink } from '@components/atoms'
import styles from './RivenditoriList.module.sass'
import { LocalitaNode } from '@gql/graphql'

interface Props {
  title?: string
  items: LocalitaNode[]
  className?: string
}

const RivenditoriList = (props: Props) => {
  const { title = undefined, items = [], className = '' } = props

  return items?.length > 0 ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={`${styles.layout}`}>
          {!!title && <h2 className={styles.title}>{title}</h2>}
          <div className={`${styles.list}`}>
            {items.map((x) => (
              <WLink href={x.slug} key={x.pk} className={styles.item}>
                {x.name}
              </WLink>
            ))}
          </div>
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default RivenditoriList
